import { Injectable } from '@angular/core';
import { HttpClientService } from './httpClient.service';
import { map } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import {CustomSite} from "../model/customsite.model";
import { Observable } from 'rxjs';
import { StringResponse } from '../model/stringresponse.model';

@Injectable()
export class CustomSiteService {

    private apiUrl: string;

    constructor(
        private http: HttpClientService,
        private configService: ConfigurationService
    ) {
        this.onConfigLoad = this.onConfigLoad.bind( this );
        configService.loadConfigurations().subscribe( this.onConfigLoad );
    }

    login(agencia) {
        return this.http.get<CustomSite>(`${this.apiUrl}/back/custom/login/${agencia}`).pipe(map(response => response));
    }

    chat(agencia) {
        return this.http.get<CustomSite>(`${this.apiUrl}/back/custom/chat/${agencia}`).pipe(map(response => response));
    }

    whatsapp(agencia: string): Observable<StringResponse> {
        return this.http.get<StringResponse>(`${this.apiUrl}/back/custom/whatsapp/${agencia}`);
    }

    private onConfigLoad( config ) {
        this.apiUrl = config.apiUrl;
    }
}
